export function createFreshEstimateDraft(overrides = {}) {
  return {
    estimateId: '',
    name: 'Untitled estimate',
    profileId: '',
    profileSnapshot: null,
    filamentGrams: 0,
    printHours: 0,
    printMinutes: 0,
    averagePowerWatts: 0,
    laborMinutes: 0,
    quantity: 1,
    additionalCost: 0,
    targetMargin: 0,
    source: null,
    ...overrides,
  };
}
